import { SVGProps } from 'react';
import { SvgSymbolIds } from '../constants';
export function IconSearchNormal(props: SVGProps<SVGSVGElement>) {
  return <svg {...props} data-sentry-element="svg" data-sentry-component="IconSearchNormal" data-sentry-source-file="search-normal.tsx">
            <use href={`#${SvgSymbolIds.SearchNormal}`} data-sentry-element="use" data-sentry-source-file="search-normal.tsx" />
        </svg>;
}